module.exports = __webpack_public_path__ + "static/media/success@3x.67fb56af.png";